import tp_icon_svg from "../../Assets/Images/trade_icon.svg";
import dip_icon_svg from "../../Assets/Images/diplomats_icon_svg.svg";
import er_icon_svg from "../../Assets/Images/expert_icon_svg.svg";
import wv_icon_svg from "../../Assets/Images/wealth_icon_svg.svg";
import tp_icon from "../../Assets/trade.gif";
import dip_icon from "../../Assets/Diplomats.gif";
import exp_icon from "../../Assets/ExpertRecommendation.gif";
import wealth_vault_icon from "../../Assets/WealthVaults.gif";
import TBlogo from "../../ui-utils/latestPics/LoginLogo.svg";
import overlay from "../../ui-utils/latestPics/loginoverlay.svg";
import React, { useState, useEffect } from "react";
import { backendHosts } from "../../ui-utils/apiConfig"
import {
  Typography,
  Grid2,
  Button,
  useMediaQuery,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
} from "@mui/material";
import { useTheme } from "@mui/material";
import styles from "./LoginMobile.module.css"
import DocumentMeta from 'react-document-meta'
const meta = {
    title: 'Secure Login Access to Your Trading Account | TradeBoss',
    description: 'Login to TradeBoss for fast, secure access to your trading account. Trade NSE, BSE stocks, bonds & IPOs anytime with complete confidence.',
    canonical: 'https://tradeboss.co/login',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'tradeboss login, trading platform login, demat account login, secure login tradeboss, login trading app, access trading account'
        }
    }
}
export default function LoginMobile(){

     const theme = useTheme();
      // const range = useMediaQuery(theme.breakpoints.between(601, 849));

      const isLargeScreen = useMediaQuery("(max-width:1564px)");
      const screenWidth1300 = useMediaQuery("(max-width:1300px)");

      const [t1, setT1] = useState(1);
      const [isTHovered, setIsTHovered] = useState(false);
      const [isDHovered, setIsDHovered] = useState(false);
      const [isEHovered, setIsEHovered] = useState(false);
      const [isWHovered, setIsWHovered] = useState(false);

      const handleLogin = () => {
        console.log("clicked");
        console.log(t1);

        const isStaging = window.location.href.includes("staging") || window.location.href.includes("localhost");
        let expertLink
        let wealthVaultLink
        if(isStaging){

                 expertLink=" https://expert-recommendation-frontend-staging.tradeboss.co/"
                 wealthVaultLink="https://wealthvault-frontend-staging.tradeboss.co/"
        }else{
                 expertLink="  https://expert-recommendation-frontend.tradeboss.co/"
                 wealthVaultLink="https://wealthvault-frontend.tradeboss.co/"
        }
        if(t1 == 1){

         window.open(backendHosts.TRADEPLF, '_blank');
        }
        else if(t1 == 2){
          window.open(backendHosts.BACKOFFICE, '_blank');
        }else if(t1 == 3){
          window.open(expertLink, '_blank');
        }
        else if(t1 == 4){
          window.open(wealthVaultLink, '_blank');
        }
      };

      const handleSignUp=()=>{
        const isStaging = window.location.href.includes("staging") || window.location.href.includes("localhost");

    console.log(isStaging)
        const baseUrl = isStaging
          ? "https://kyc-frontend-staging.tradeboss.co"
          : "https://kyc.tradeboss.co";

          window.location.href = baseUrl;
      }
    return (
        <>
            <Box className={styles.HomeSectionBox}>
               <DocumentMeta {...meta} />

                <Box
                    component="img"
                    src={overlay}
                    alt="Top illustration"
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "50%",
                        objectFit: "cover",
                        opacity: 0.3,
                        "@media (max-width: 800px)": {
                            height: "40%",
                        },
                        "@media (max-width: 400px)": {
                            height: "30%",
                        },

                    }}
                />
                <Grid2
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Grid2
                        sx={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "center",
                            gap: "5rem",
                        }}
                    >


                        <Grid2
                            sx={{
                                width: "80%",
                                minHeight: "700px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                "@media screen and (max-width:780px)": {
                                    width: "100%"
                                },
                            }}
                        >
                            <Grid2
                                container
                                sx={{

                                    borderRadius: "28px",

                                }}
                                className={styles.loginCard}
                            >
                                {/* <Grid2
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <img
                  src={bull}
                  alt="bulllogo"
                  width={screenWidth1300 ? "500px" : "577px"}
                ></img>
              </Grid2> */}

                                <Grid2
                                    style={{
                                        width: "70%",
                                        marginTop: "3%",
                                        marginLeft: "15%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                    className={styles.LoginnowGrid}
                                >
                                    <Typography className={styles.card_tit}>Login now</Typography>
                                </Grid2>

                                {/* 1st button */}
                                <Grid2
                                    style={{
                                        width: "100%",
                                        marginTop: "3%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <Grid2
                                        className={
                                            t1 === 1 ? styles.sel_button : styles.sel_button_dis
                                        }
                                        onClick={() => setT1(1)}
                                        onMouseEnter={() => setIsTHovered(true)}
                                        onMouseLeave={() => setIsTHovered(false)}
                                    >
                                        <Grid2
                                            container
                                            style={{
                                                width: "15%",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignContent: "center",

                                            }}
                                        >
                                            <div
                                                style={{
                                                    borderRadius: "50%",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <div className={styles.imageContainer}>
                                                    <img
                                                        src={tp_icon_svg}
                                                        alt="bulllogo"
                                                        className={styles.svgImage}
                                                        style={{ opacity: isTHovered ? 0 : 1 }}
                                                    />
                                                    <img
                                                        src={tp_icon}
                                                        alt="bulllogo"
                                                        className={styles.gifImage}
                                                        style={{ opacity: isTHovered ? 1 : 0 }}
                                                    />
                                                </div>
                                            </div>
                                        </Grid2>
                                        <Grid2
                                            container
                                            style={{
                                                width: "75%",
                                                marginLeft: "3%",
                                                justifyContent: "start",
                                                alignContent: "center",
                                            }}
                                        >
                                            <Typography className={t1 === 1 ? styles.d1 : styles.d2}>
                                                Trading Platform
                                            </Typography>
                                        </Grid2>
                                        {t1 === 1 && (
                                            <Grid2 style={{ width: "10%", alignContent: "center" }}>
                                                <RadioGroup row defaultValue="indian">
                                                    <FormControlLabel
                                                        value="indian"
                                                        control={
                                                            <Radio
                                                                inputProps={{
                                                                    "aria-label": "Indian",
                                                                }}
                                                                disableRipple
                                                                size="small"
                                                                checked
                                                                sx={{
                                                                    color: "#999999",
                                                                    "&.Mui-checked": {
                                                                        position: "relative",
                                                                        "&::before": {
                                                                            content: '""',
                                                                            position: "absolute",
                                                                            top: "50%",
                                                                            left: "50%",
                                                                            transform: "translate(-50%, -50%)",
                                                                            width: "24px",
                                                                            height: "24px",
                                                                            borderRadius: "50%",
                                                                            backgroundColor: "#17164F", // Outer circle color
                                                                            border: "2px solid #F3D45E", // Yellow border
                                                                        },
                                                                        "&::after": {
                                                                            content: '""',
                                                                            position: "absolute",
                                                                            top: "50%",
                                                                            left: "50%",
                                                                            transform: "translate(-50%, -50%)",
                                                                            width: "12px",
                                                                            height: "12px",
                                                                            borderRadius: "50%",
                                                                            backgroundColor: "#F3D45E", // Inner circle color
                                                                        },
                                                                        "& .MuiSvgIcon-root": {
                                                                            visibility: "hidden", // Hide default radio button
                                                                        },
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                    />
                                                </RadioGroup>
                                            </Grid2>
                                        )}
                                    </Grid2>
                                </Grid2>

                                {/* 2nd button */}
                                {/* <Grid2
                style={{
                  width: "100%",
                  marginTop: "3%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Grid2
                  className={
                    t1 === 2 ? styles.sel_button : styles.sel_button_dis
                  }
                  onClick={() => setT1(2)}
                  onMouseEnter={() => setIsDHovered(true)}
                  onMouseLeave={() => setIsDHovered(false)}
                >
                  <Grid2
                    container
                    style={{
                      width: "15%",
                      display: "flex",
                      justifyContent: "center",
                      alignContent: "center",
                    }}
                  >
                    <div
                      style={{
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div className={styles.imageContainer}>
                        <img
                          src={dip_icon_svg}
                          alt="bulllogo"
                          className={styles.svgImage}
                          style={{ opacity: isDHovered ? 0 : 1 }}
                        />
                        <img
                          src={dip_icon}
                          alt="bulllogo"
                          className={styles.gifImage}
                          style={{ opacity: isDHovered ? 1 : 0 }}
                        />
                      </div>
                    </div>
                  </Grid2>
                  <Grid2
                    container
                    style={{
                      width: "75%",
                      marginLeft: "3%",
                      justifyContent: "start",
                      alignContent: "center",
                    }}
                  >
                    <Typography className={t1 === 2 ? styles.d1 : styles.d2}>
                     Backoffice
                    </Typography>
                  </Grid2>
                  {t1 === 2 && (
                    <Grid2 style={{ width: "10%", alignContent: "center" }}>
                      <RadioGroup row defaultValue="indian">
                        <FormControlLabel
                          value="indian"
                          control={
                            <Radio
                              disableRipple
                              size="small"
                              checked
                              sx={{
                                color: "#999999",
                                "&.Mui-checked": {
                                  position: "relative",
                                  "&::before": {
                                    content: '""',
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    width: "24px",
                                    height: "24px",
                                    borderRadius: "50%",
                                    backgroundColor: "#17164F", // Outer circle color
                                    border: "2px solid #F3D45E", // Yellow border
                                  },
                                  "&::after": {
                                    content: '""',
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    width: "12px",
                                    height: "12px",
                                    borderRadius: "50%",
                                    backgroundColor: "#F3D45E", // Inner circle color
                                  },
                                  "& .MuiSvgIcon-root": {
                                    visibility: "hidden", // Hide default radio button
                                  },
                                },
                              }}
                            />
                          }
                        />
                      </RadioGroup>
                    </Grid2>
                  )}
                </Grid2>
              </Grid2> */}

                                {/* 3rd button */}
                                <Grid2
                                    style={{
                                        width: "100%",
                                        marginTop: "3%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <Grid2
                                        className={
                                            t1 === 3 ? styles.sel_button : styles.sel_button_dis
                                        }
                                        onClick={() => setT1(3)}
                                        onMouseEnter={() => setIsEHovered(true)}
                                        onMouseLeave={() => setIsEHovered(false)}
                                    >
                                        <Grid2
                                            container
                                            sx={{
                                                width: "15%",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignContent: "center",

                                            }}
                                        >
                                            <div
                                                style={{
                                                    borderRadius: "50%",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <div className={styles.imageContainer}>
                                                    <img
                                                        src={er_icon_svg}
                                                        alt="bulllogo"
                                                        className={styles.svgImage}
                                                        style={{ opacity: isEHovered ? 0 : 1 }}
                                                    />
                                                    <img
                                                        src={exp_icon}
                                                        alt="bulllogo"
                                                        className={styles.gifImage}
                                                        style={{ opacity: isEHovered ? 1 : 0 }}
                                                    />
                                                </div>
                                            </div>
                                        </Grid2>
                                        <Grid2
                                            container
                                            sx={{
                                                width: "75%",
                                                marginLeft: "3%",
                                                justifyContent: "start",
                                                alignContent: "center",

                                            }}
                                        >
                                            <Typography className={t1 === 3 ? styles.d1 : styles.d2}>
                                                Expert Recommendation
                                            </Typography>
                                        </Grid2>
                                        {t1 === 3 && (
                                            <Grid2 style={{ width: "10%", alignContent: "center" }}>
                                                <RadioGroup row defaultValue="indian">
                                                    <FormControlLabel
                                                        value="indian"
                                                        control={
                                                            <Radio
                                                                inputProps={{
                                                                    "aria-label": "Indian",
                                                                }}
                                                                disableRipple
                                                                size="small"
                                                                checked
                                                                sx={{
                                                                    color: "#999999",
                                                                    "&.Mui-checked": {
                                                                        position: "relative",
                                                                        "&::before": {
                                                                            content: '""',
                                                                            position: "absolute",
                                                                            top: "50%",
                                                                            left: "50%",
                                                                            transform: "translate(-50%, -50%)",
                                                                            width: "24px",
                                                                            height: "24px",
                                                                            borderRadius: "50%",
                                                                            backgroundColor: "#17164F", // Outer circle color
                                                                            border: "2px solid #F3D45E", // Yellow border
                                                                        },
                                                                        "&::after": {
                                                                            content: '""',
                                                                            position: "absolute",
                                                                            top: "50%",
                                                                            left: "50%",
                                                                            transform: "translate(-50%, -50%)",
                                                                            width: "12px",
                                                                            height: "12px",
                                                                            borderRadius: "50%",
                                                                            backgroundColor: "#F3D45E", // Inner circle color
                                                                        },
                                                                        "& .MuiSvgIcon-root": {
                                                                            visibility: "hidden", // Hide default radio button
                                                                        },
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                    />
                                                </RadioGroup>
                                            </Grid2>
                                        )}
                                    </Grid2>
                                </Grid2>


                                <Grid2
                                    style={{
                                        width: "100%",
                                        marginTop: "3%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <Grid2
                                        className={
                                            t1 === 4 ? styles.sel_button : styles.sel_button_dis
                                        }
                                        onClick={() => setT1(4)}
                                        onMouseEnter={() => setIsWHovered(true)}
                                        onMouseLeave={() => setIsWHovered(false)}
                                    >
                                        <Grid2
                                            container
                                            style={{
                                                width: "15%",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignContent: "center",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    borderRadius: "50%",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <div className={styles.imageContainer}>
                                                    <img
                                                        src={wv_icon_svg}
                                                        alt="bulllogo"
                                                        className={styles.svgImage}
                                                        style={{ opacity: isWHovered ? 0 : 1 }}
                                                    />
                                                    <img
                                                        src={wealth_vault_icon}
                                                        alt="bulllogo"
                                                        className={styles.gifImage}
                                                        style={{ opacity: isWHovered ? 1 : 0 }}
                                                    />
                                                </div>
                                            </div>
                                        </Grid2>
                                        <Grid2
                                            container
                                            style={{
                                                width: "75%",
                                                marginLeft: "3%",
                                                justifyContent: "start",
                                                alignContent: "center",
                                            }}
                                        >
                                            <Typography className={t1 === 4 ? styles.d1 : styles.d2}>
                                                Wealth Vaults
                                            </Typography>
                                        </Grid2>
                                        {t1 === 4 && (
                                            <Grid2 style={{ width: "10%", alignContent: "center" }}>
                                                <RadioGroup row defaultValue="indian">
                                                    <FormControlLabel
                                                        value="indian"
                                                        inputProps={{
                                                            "aria-label": "Indian",
                                                        }}
                                                        control={
                                                            <Radio
                                                                disableRipple
                                                                size="small"
                                                                checked
                                                                sx={{
                                                                    color: "#999999",
                                                                    "&.Mui-checked": {
                                                                        position: "relative",
                                                                        "&::before": {
                                                                            content: '""',
                                                                            position: "absolute",
                                                                            top: "50%",
                                                                            left: "50%",
                                                                            transform: "translate(-50%, -50%)",
                                                                            width: "24px",
                                                                            height: "24px",
                                                                            borderRadius: "50%",
                                                                            backgroundColor: "#17164F", // Outer circle color
                                                                            border: "2px solid #F3D45E", // Yellow border
                                                                        },
                                                                        "&::after": {
                                                                            content: '""',
                                                                            position: "absolute",
                                                                            top: "50%",
                                                                            left: "50%",
                                                                            transform: "translate(-50%, -50%)",
                                                                            width: "12px",
                                                                            height: "12px",
                                                                            borderRadius: "50%",
                                                                            backgroundColor: "#F3D45E", // Inner circle color
                                                                        },
                                                                        "& .MuiSvgIcon-root": {
                                                                            visibility: "hidden", // Hide default radio button
                                                                        },
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                    />
                                                </RadioGroup>
                                            </Grid2>
                                        )}
                                    </Grid2>
                                </Grid2>


                                <Grid2
                                    style={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignContent: "center",
                                    }}
                                >
                                    <Grid2
                                        sx={{
                                            width: "70%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignContent: "center",
                                            "@media screen and (max-width:780px)": {
                                                width: "70%"
                                            },
                                            "@media screen and (max-width:600px)": {
                                                width: "80%"
                                            },
                                        }}
                                    >
                                        <Button
                                            fullWidth
                                            className={styles.joinDiplomtsBtn}
                                            style={{ marginTop: "41px" }}
                                            onClick={handleLogin}
                                        >
                                            Login
                                        </Button>
                                    </Grid2>
                                </Grid2>


                                <Grid2
                                    style={{
                                        marginTop: "3%",
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        marginBottom: "47px",
                                    }}
                                    className={styles.DonntStyle}
                                >
                                    <Typography className={styles.d3}>
                                        Don’t have an account?{" "}
                                    </Typography>
                                    <Typography
                                        className={styles.d4}
                                        sx={{ marginLeft: "1%", cursor: "pointer !important" }}
                                        onClick={handleSignUp}
                                    >
                                        Register
                                    </Typography>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    </Grid2>
                </Grid2>
            </Box>
        </>
    )
}